<template>
  <div class="popup-info popup-icon-info">
      <svg style="height: 48px;">
        <use xlink:href="@/assets/img/big-icons-sprite.svg#error-update"></use>
      </svg>

      <div class="text mt24">
          <div class="text-size-l text-bold info-title text-color-red2" >Вы пытаетесь перезагрузить страницу редактора</div>

          <p class="info-text mt8">
             Выберите подходящий вариант
          </p>
      </div>

      <div class="mt24">
          <button class="btn full" @click="save">сохранить изменения и перезагрузить</button>
          <button class="btn mt16 btn--white-yellow full" @click="close">Остаться в редакторе и не перезагружать</button>
      </div>
  </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "TryingUpdate",
        components: {
            SubmitBtn
        },
        data() {
            return {
                btnType: 'normal',
            }
        },
        props: {
        },
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.tryingUpdate.name});
            },
            save: function () {
                this.$emit('autoSave', {'autoSave':true});
                this.$store.commit('popups/close', {name: this.popups.tryingUpdate.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.editItem,
                topSections: state => state.rules.topSections,
            }),
            activeTopSection(){
                if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
        }
    }
</script>

<style scoped>

</style>
